import i18n from 'i18next';

import { AreaUnit } from '../../../../graphql/graphql';

const areaUnitsSingular = {
  [AreaUnit.Acres]: 'area-units.singular.acres',
  [AreaUnit.Hectares]: 'area-units.singular.hectares',
} as Record<AreaUnit, string>;

const areaUnitsPlural = {
  [AreaUnit.Acres]: 'area-units.plural.acres',
  [AreaUnit.Hectares]: 'area-units.plural.hectares',
} as Record<AreaUnit, string>;

const areaUnitsShort = {
  [AreaUnit.Acres]: 'area-units.short.acres',
  [AreaUnit.Hectares]: 'area-units.short.hectares',
} as Record<AreaUnit, string>;

export const getSingularAreaUnit = (areaUnit: AreaUnit): string =>
  i18n.t(areaUnitsSingular[areaUnit]);

export const getPluralAreaUnit = (areaUnit: AreaUnit): string =>
  i18n.t(areaUnitsPlural[areaUnit]);

export const getShortAreaUnit = (areaUnit: AreaUnit): string =>
  i18n.t(areaUnitsShort[areaUnit]);
